module.exports = __webpack_public_path__ + "public/Icons/refreshIcon.svg?8b8e5fad";